module.exports = __webpack_public_path__ + "img/grammatical.2bebf01c.svg";